import { useState, useEffect } from 'react'
import { readStored, writeStored } from '../utils/safeStorage'

export function useTheme() {
  // Read through safeStorage: this is a first-render read, and localStorage
  // throws with site data blocked or in an iframe with third-party cookies
  // off, which took the app down instead of costing it a theme.
  const [theme, setTheme] = useState(
    () => readStored('theme', 'dark') || 'dark'
  )

  useEffect(() => {
    // The attribute is what actually themes the page, so it is set first and
    // unconditionally. Remembering the choice is the optional half.
    document.documentElement.setAttribute('data-theme', theme)
    writeStored('theme', theme)
  }, [theme])

  function toggle() {
    setTheme(t => (t === 'dark' ? 'light' : 'dark'))
  }

  return { theme, toggle }
}
